<div class="panel-header">
    <h3 class="row">
        <div class="material-icons-outlined col-xs-1">
            filter_none
        </div>
        <div i18n="@@phx.panelVersion.versions" class="col-xs-4">Versions</div>
        <div class="col-xs-7">
            <app-phx-version-comparison-toggle></app-phx-version-comparison-toggle>
        </div>
    </h3>
</div>
<div class="v-panel">
    <div *ngIf="!multiple && sortedVersions && sortedVersions?.length" class="v-single">
        <ng-container *ngTemplateOutlet="versionListTpl; context: { $implicit:sortedVersions }">
        </ng-container>
    </div>
    <accordion *ngIf="multiple && groupedVersions && groupedVersions.length" class="accord-bd-0" [isAnimated]="true"
        [closeOthers]="true">
        <accordion-group [isOpen]="obj.isActive" class="v-ac-group" [class.active]="obj.isActive"
            *ngFor="let obj of groupedVersions; let i = index" #group>
            <div class="v-ac-head" accordion-heading>
                <div>
                    <p class="font-weight-600">{{ entityType }} {{ obj.entityId }}</p>
                    <ng-container *ngIf="obj.versions.length as count">
                        <p>
                            <span *ngIf="count > 1">
                                {{ obj.versions[count-1].EffectiveDate | date:
                                phxConstants.DateFormat.mediumDate }}
                                -
                            </span>
                            {{ obj.versions[0].EffectiveDate | date: phxConstants.DateFormat.mediumDate }}
                        </p>
                    </ng-container>
                </div>
                <div>
                    <i *ngIf="groupedVersions.length > 1" class="glyphicon"
                        [ngClass]="{'glyphicon-menu-up': group.isOpen, 'glyphicon-menu-down': !group.isOpen}"></i>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="versionListTpl; context: { $implicit:obj.versions }">
            </ng-container>
        </accordion-group>
    </accordion>
</div>

<ng-template #versionListTpl let-versions>
    <div class="v-item" *ngFor="let version of versions" (click)="selectVersion(version)"
        [ngClass]="{
            'version-comparison-source': (comparisonSourceVersionNumber$ | async) === version.VersionNumber,
            'active': version.VersionNumber === currentVersion
        }"
        title="{{
            version.VersionNumber === currentVersion ? 'Viewing: ' : ''}}{{
            (comparisonSourceVersionNumber$ | async) === version.VersionNumber ? 'Comparing to: ' : ''}}{{
            version.Id + '.' + version.VersionNumber
        }}">
        <div class="padding-left-15">
            <p class="v-num" i18n="@@phx.panelVersion.versionNumber">
                Version {{ version.VersionNumber }}</p>

            <p class="v-status" *ngIf="statusGroup">
                <ng-container *ngIf="version.StatusId">
                    {{ version.StatusId | CodeValue: statusGroup: 'text'}}
                </ng-container>
                <ng-container *ngIf="version.StatusCode && !version.StatusId">
                    {{ version.StatusCode | CodeValueByCode: statusGroup: 'text'}}
                </ng-container>
            </p>
        </div>
        <div>
            <p class="v-num" i18n="@@phx.panelVersion.effectiveDate">
                Effective {{ version.EffectiveDate | date: phxConstants.DateFormat.mediumDate }}</p>
        </div>
    </div>
</ng-template>